import IMask from "imask"; // ensure bundler includes this dependency
import { useIMask } from "react-imask";
import { LabeledInput, LabeledInputProps } from "@phoenix/core/components/forms/LabeledInput";

export type LabeledPhoneNumberProps = LabeledInputProps & {
  mask?: string;
  onMaskedValueChanged: (maskedValue: string, unmaskedValue: string) => void;
}

export const LabeledPhoneNumber = ({
  mask,
  onMaskedValueChanged,
  ...props }: LabeledPhoneNumberProps) => {
  const { ref } = useIMask(
    {
      mask: mask || "000-000-0000", // required pattern
      lazy: true,                    // always show dashes
      overwrite: true,                // type-over behavior
    },
    {
      // Fires on *any* accepted typed value
      onAccept: (maskedValue, maskRef) => {
        // e.g. maskedValue "1-234-567-8910"
        // e.g. maskRef.unmaskedValue "12345678910"
        onMaskedValueChanged(maskedValue, maskRef.unmaskedValue);
      },
    }
  );

  return (
    <LabeledInput
      {...props}
      placeholder="111-111-1111"
      // @ts-expect-error ref type does not match
      ref={ref}
    />
  );
};
LabeledPhoneNumber.displayName = "LabeledPhoneNumber";
